module.exports = __webpack_public_path__ + "e6e3fd76666f5b9ba060451a8a735dba.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/PageApp/NewLogo.png
 ** module id = 1261
 ** module chunks = 0
 **/